// Static imports - more reliable
import Home from "../../../views/front/home/Home.vue";
import PrivacyPolicy from "../../../views/front/privacyPolicy/PrivacyPolicy.vue";
import TradeCondition from "../../../views/front/tradeCondition/TradeCondition.vue";
import Discovery from "../../../views/front/discovery/Discovery.vue";
import CheckoutQuick from "../../../views/front/checkout/CheckoutQuick.vue";
import Checkout from "../../../views/front/checkout/Checkout.vue";
import FlatPayPayment from "../../../views/front/checkout/FlatPayPayment.vue";
import PaymentProgress from "../../../views/front/checkout/PaymentProgress.vue";
import Thanks from "../../../views/front/thanks/Thanks.vue";
import QuickOrderThanks from "../../../views/front/thanks/QuickOrderThanks.vue";
import Profile from "../../../views/front/profile/Profile.vue";
import ResetPassword from "../../../views/front/resetPassword/ResetPassword.vue";

export default [
  {
    path: "/",
    name: "Home",
    component: Home,
    hidden: true,
    meta: {
      title: "Home",
      noCache: true,
    },
  },
  {
    path: "/privacy-policy",
    // path: "/",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    hidden: true,
    meta: {
      title: "Privacy policy",
      noCache: true,
    },
  },
  {
    path: "/trade-condition",
    // path: "/",
    name: "TradeCondition",
    component: TradeCondition,
    hidden: true,
    meta: {
      title: "Trade condition",
      noCache: true,
    },
  },
  {
    path: "/:id/discovery",
    name: "Discovery",
    component: Discovery,
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Discovery",
      noCache: true,
    },
  },
  {
    path: "/:id/menu/:tableId",
    name: "Menu",
    component: Discovery,
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Menu",
      noCache: true,
    },
  },
  {
    path: "/:id/checkout/:tableId",
    name: "CheckoutQuick",
    component: CheckoutQuick,
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Checkout",
      noCache: true,
    },
  },
  {
    path: "/:id/checkout",
    name: "Checkout",
    component: Checkout,
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Checkout",
      noCache: true,
    },
  },
  {
    path: "/:id/flatpay",
    name: "FlatPayPayment",
    component: FlatPayPayment,
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Flatpay Payment",
      noCache: true,
    },
  },
  {
    path: "/:id/payment",
    name: "PaymentProgress",
    component: PaymentProgress,
    props: (route) => ({ id: route.params.id }),
    hidden: true,
    meta: {
      title: "Payment Progress",
      noCache: true,
    },
  },
  {
    path: "/:id/thanks/:orderref",
    name: "Thanks",
    hidden: true,
    component: Thanks,
    props: (route) => ({ propOrderRef: route.params.orderref }),
    meta: {
      title: "Thanks",
      noCache: true,
    },
  },
  {
    path: "/:id/thanks/:tableId/:orderref",
    name: "ThanksQuick",
    hidden: true,
    component: QuickOrderThanks,
    props: (route) => ({ propOrderRef: route.params.orderref }),
    meta: {
      title: "Thanks",
      noCache: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    hidden: true,
    component: Profile,
    meta: {
      title: "Profile",
      noCache: true,
    },
  },
  {
    path: "/password/reset",
    name: "ResetPassword",
    hidden: true,
    component: ResetPassword,
    meta: {
      title: "ResetPassword",
      noCache: true,
    },
  },
];
